/* Details main container */

.spotify-player-track-details {
  background-color: var(--darkest);
  height: 100%;
  max-height: min(100%, var(--spotify-player-panel-max-height, 60vh));
  padding: 1.2em;
  border-radius: 0.5em;
  border: 1px solid var(--grey);
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
  overflow-y: auto;
  scrollbar-gutter: stable;
  min-height: 0;
  min-width: 0;
}

.spotify-player-track-details h4 {
  font-weight: bold;
  font-size: larger;
  margin-bottom: 0.4em;
}

/* Table layout */

.spotify-player-track-details-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.spotify-player-track-details-row {
  display: flex;
  justify-content: space-between;
  padding: 0.1em 0;
}

.spotify-player-track-details-cell {
  padding: 0.1em;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.8em;
}

/* Key-value cell layout */

.spotify-player-key-cell {
  font-weight: bold;
  color: var(--lightest);
  flex-basis: 30%;
}

.spotify-player-value-cell {
  flex-basis: 70%;
  color: var(--lightest);
  user-select: text;
}

/* Only message layout */

.spotify-player-textinfo-explicit {
  display: inline-block;
  font-size: 0.55em;
  font-weight: bold;
  background-color: var(--grey);
  color: var(--lightest);
  padding: 0.1em 0.35em;
  border-radius: 0.2em;
  margin-left: 0.5em;
  vertical-align: middle;
}

/* Context / "Playing from" section */

.spotify-player-context-section {
  margin-top: 0.8em;
  padding-top: 0.6em;
  border-top: 1px solid var(--grey);
}

.spotify-player-context-header {
  display: flex;
  align-items: baseline;
  gap: 0.4em;
  margin-bottom: 0.3em;
  font-size: 0.9em;
}

.spotify-player-context-type {
  font-size: 0.65em;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--lighter);
  opacity: 0.6;
  background: var(--grey);
  padding: 0.1em 0.4em;
  border-radius: 0.2em;
  flex-shrink: 0;
}

.spotify-player-context-header .spotify-player-browse-link {
  font-weight: bold;
  font-size: 1em;
}

.spotify-player-context-description {
  font-style: italic;
  opacity: 0.7;
  padding-top: 0.3em;
}

.spotify-player-message {
  width: 100%;
  word-wrap: break-word;
  text-wrap: wrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 1.0em;
  color: var(--lightest);
  user-select: text;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-items: center;
  align-content: center;
}
